export default __webpack_public_path__ + "static/9-24ab93ca46a5eff2a89f8bca3d009907.webp";